export default function PrivacyPolicy() {
  return (
    <div className="container mx-auto max-h-[80vh] px-4 py-4 sm:py-8">
      <div className="mx-auto flex min-h-screen flex-col items-center bg-background-light p-4 dark:bg-background-dark">
        <h1 className="mb-4 text-4xl font-bold text-gray-900 dark:text-gray-100">Privacy Policy</h1>
        <p className="mb-4 text-center text-lg text-gray-900 dark:text-gray-100">
          Welcome to TrackToss! Your privacy is important to us. This privacy policy outlines how we
          collect, use, and protect your information when you use our web application.
        </p>

        <section>
          <div className="mx-auto">
            <h2 className="mt-10 text-center text-2xl font-bold">What We Collect </h2>
            <p className="mb-4 text-center text-base text-gray-900 dark:text-gray-100">
              We do not collect any personal information such as your name, email address, or
              location. <br></br> The only data stored is a randomly generated identifier (a cookie)
              that allows the person who created a playlist (the host) to play that playlist.
            </p>
          </div>
        </section>

        <section>
          <div className="mx-auto">
            <h2 className="mt-10 text-center text-2xl font-bold">Cookies </h2>
            <p className="mb-4 text-center text-base text-gray-900 dark:text-gray-100"></p> We use a
            single cookie for functional purposes only. <br></br> This cookie:
            <ul className="mb-4 list-inside list-disc text-base text-gray-900 dark:text-gray-100">
              <li>Is randomly generated</li>
              <li>Does not contain any personal or identifiable information</li>
              <li>Is used solely to associate you with a playlist you created</li>
            </ul>
            <p className="mb-4 text-center text-base text-gray-900 dark:text-gray-100">
              This cookie is stored in your browser and is not shared with any third parties.
            </p>
          </div>
        </section>

        <section>
          <div className="mx-auto">
            <h2 className="mt-10 text-center text-2xl font-bold">Third Party Sharing </h2>
            <p className="mb-4 text-center text-base text-gray-900 dark:text-gray-100">
              We do not share, sell, or transfer any data to third parties.
            </p>
          </div>
        </section>

        <section>
          <div className="mx-auto">
            <h2 className="mt-10 text-center text-2xl font-bold">Changes to This Policy </h2>
            <p className="mb-4 text-center text-base text-gray-900 dark:text-gray-100">
              If we make changes to how we handle data or cookies, we will update this page. We
              recommend checking back occasionally for any updates.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
